// src/components/TeacherRoute.js
import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getTeacherByAuthUid } from '../utils/teacherHelper';

function TeacherRoute({ children }) {
  const { user, authLoading } = useAuth();
  const [state, setState] = useState({ loading: true, teacher: null });

  useEffect(() => {
    let cancelled = false;
    async function check() {
      if (authLoading) return;
      if (!user) { setState({ loading: false, teacher: null }); return; }
      try {
        const teacher = await getTeacherByAuthUid(user.uid);
        if (!cancelled) setState({ loading: false, teacher });
      } catch (e) {
        console.error('TeacherRoute lookup error:', e);
        if (!cancelled) setState({ loading: false, teacher: null });
      }
    }
    check();
    return () => { cancelled = true; };
  }, [user, authLoading]);

  if (authLoading || state.loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-gray-600 text-lg">Loading...</div>
      </div>
    );
  }

  // Not authenticated -> login
  if (!user) return <Navigate to="/login" replace />;

  // Authenticated but no teacher record -> not a teacher, send home
  if (!state.teacher) return <Navigate to="/" replace />;

  // Teacher record exists but deactivated -> terminal notice, NO redirect
  // (redirecting here would cause a /teacher <-> / loop with ProtectedRoute)
  if (state.teacher.active === false) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center max-w-md">
          <div className="text-4xl mb-4">🔒</div>
          <h1 className="text-xl font-bold text-gray-800 mb-2">Account Inactive</h1>
          <p className="text-gray-600">
            Your teacher account is currently inactive. Please contact an
            administrator if you believe this is a mistake.
          </p>
        </div>
      </div>
    );
  }

  return children;
}

export default TeacherRoute;
